import { RowModel, flexRender } from '@tanstack/react-table'

import { Tbody, Td, Tr } from '@chakra-ui/react'

import { TableSpinner } from '@/components/ui'

export const ROW_HEIGHT = 57

interface TableBodyIProps<DataT> {
  isLoading?: boolean
  pageSize?: number
  rowModel: RowModel<DataT>
  rowHeight?: number
  onRowClick?: (rowId: string) => void
  [key: string]: unknown
}

export const TableBody = <DataT,>({
  isLoading,
  pageSize,
  rowModel,
  rowHeight = ROW_HEIGHT,
  onRowClick,
  ...rest
}: TableBodyIProps<DataT>) => {
  if (isLoading) {
    return <TableSpinner height={`${pageSize * rowHeight}px`} />
  }

  return (
    <Tbody position='relative'>
      {rowModel?.rows.map((row) => (
        <Tr
          _hover={{
            bgColor: 'gray.100',
          }}
          cursor='pointer'
          data-testid={`row-${row.id}`}
          height={`${rowHeight}px`}
          key={row.id}
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='all'
        >
          {row.getVisibleCells().map((cell) => (
            <Td
              color='#838692'
              fontSize='14px'
              fontWeight={500}
              key={cell.id}
              onClick={(e) => {
                if (cell?.column?.columnDef?.meta?.ignoreClicksToCell) {
                  e.stopPropagation()
                  return
                }

                const originalObject = row.original as { id: string }
                const rowId = originalObject?.id
                onRowClick?.(rowId)
              }}
              {...rest}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </Td>
          ))}
        </Tr>
      ))}
    </Tbody>
  )
}
